module.exports = __webpack_public_path__ + "img/tkd_kicks_high.60d73575.svg";